import ServicePage from "./ServiceTemplate";
export default function PelvicFloor() { return <ServicePage serviceId="pelvic-floor" />; }
